import { useCallback, useEffect, useState } from 'react'
import { useToast } from '@chakra-ui/react'
import { EstadoPush, ativarPush, estadoDoPush } from '../services/webPush'

/** Estado do push deste navegador + ação de ativar (sempre a partir de um clique). */
export function useWebPush() {
  const toast = useToast()
  const [estado, setEstado] = useState<EstadoPush | 'carregando'>('carregando')
  const [ativando, setAtivando] = useState(false)

  useEffect(() => {
    let vivo = true
    estadoDoPush().then((e) => vivo && setEstado(e))
    return () => {
      vivo = false
    }
  }, [])

  const ativar = useCallback(async () => {
    setAtivando(true)
    try {
      const novo = await ativarPush()
      setEstado(novo)
      if (novo === 'ativo') {
        toast({
          position: 'top-right',
          status: 'success',
          title: 'Notificações ativadas',
          description:
            'Você vai receber os chamados e mensagens mesmo com o painel fechado.',
          duration: 5000,
        })
      } else if (novo === 'bloqueado') {
        toast({
          position: 'top-right',
          status: 'warning',
          title: 'Notificações bloqueadas neste navegador',
          description:
            'Para liberar, clique no cadeado ao lado do endereço do site e permita as notificações.',
          duration: 9000,
          isClosable: true,
        })
      }
      return novo
    } catch {
      const atual = await estadoDoPush()
      setEstado(atual)
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Não foi possível ativar as notificações',
        description: 'Recarregue a página e tente de novo.',
        duration: 6000,
      })
      return atual
    } finally {
      setAtivando(false)
    }
  }, [toast])

  return { estado, ativar, ativando }
}
